<div
  class="flex flex-col transition-all"
  [ngClass]="{
    'w-[256px]': vm().expanded,
    'w-[88px]': !vm().expanded,
  }"
>
  <div class="flex items-center h-[100px] overflow-hidden">
    <a
      routerLink="/"
      class="grow flex justify-center shrink-0"
      [ngClass]="{
        'w-[256px]': vm().expanded,
        'w-[88px]': !vm().expanded,
      }"
    >
      <img
        class="shrink-0 max-w-none"
        [ngClass]="{
          hidden: !vm().expanded,
        }"
        [width]="vm().expandedLogoWidth"
        [height]="vm().expandedLogoHeight"
        [src]="vm().expandedLogoSrc"
        [style.width.px]="vm().expandedLogoWidth"
        [style.height.px]="vm().expandedLogoHeight"
        alt="logo"
      />

      <img
        class="shrink-0 max-w-none"
        [ngClass]="{
          hidden: vm().expanded,
        }"
        [width]="vm().collapsedLogoWidth"
        [height]="vm().collapsedLogoHeight"
        [src]="vm().collapsedLogoSrc"
        [style.width.px]="vm().collapsedLogoWidth"
        [style.height.px]="vm().collapsedLogoHeight"
        alt="logo"
      />
    </a>
  </div>
  <div class="flex flex-col px-2 pb-2">
    @for (route of routes(); track route.labelTranslationKey) {
      @let validAccordingToFeatureFlags = !route.featureFlags || (route.featureFlags | hasFeatureFlags);
      @let validAccordingToPermissions = !route.permissions || (route.permissions | hasPermission);
      @let dashboardEnabled = !route.hideWhenDashboardDisabled || isDashboardEnabled();
      @let globalChargersEnabled = !route.hideWhenGlobalChargersDisabled || isGlobalChargersEnabled();
      @let globalVehiclesEnabled = !route.hideWhenGlobalVehiclesDisabled || isGlobalVehiclesEnabled();
      @if (
        validAccordingToFeatureFlags && validAccordingToPermissions && dashboardEnabled && globalChargersEnabled && globalVehiclesEnabled
      ) {
        @let navigationIsBlocked = route.blockNavigationWhileSiteListIsLoading && siteListIsInitialLoading();
        @if (navigationIsBlocked) {
          <div class="overflow-hidden rounded-radius-secondary">
            <div class="menu-item-container border-foreground-primary-8 flex items-center min-h-[72px] w-[240px]">
              <div class="flex pl-6 pr-4">
                <app-loading-skeleton class="w-[24px] h-[24px]" viewBox="0 0 24 24">
                  <svg:rect x="0" y="0" rx="4" ry="4" width="24" height="24" />
                </app-loading-skeleton>
              </div>
              @if (vm().expanded) {
                <app-loading-skeleton class="w-[120px] h-[20px]" viewBox="0 0 120 20">
                  <svg:rect x="0" y="0" rx="4" ry="4" width="120" height="20" />
                </app-loading-skeleton>
              }
            </div>
          </div>
        } @else {
          <div
            routerLinkActive="rla"
            [routerLinkActiveOptions]="{
              exact: !!route.exact,
            }"
            [appPopover]="vm().expanded ? '' : (route.labelTranslationKey | translate)"
            position="right-middle"
            class="overflow-hidden rounded-radius-secondary"
          >
            <a [routerLink]="route.route" class="block">
              <div class="menu-item-container transition-colors border-foreground-primary-8 flex items-center min-h-[72px] w-[240px]">
                <div class="flex pl-6 pr-4">
                  <svg-icon class="transition-colors" [key]="route.icon" size="xl"></svg-icon>
                </div>
                <div
                  class="grow text-base font-medium transition-all"
                  [ngClass]="{
                    'translate-x-[0px]': vm().expanded,
                    'translate-x-[10px]': !vm().expanded,
                  }"
                >
                  {{ route.labelTranslationKey | translate }}
                </div>
                <div class="p-2 self-stretch flex">
                  <div class="active-route-indicator w-2 shrink-0 rounded-radius-tertiary transition-colors"></div>
                </div>
              </div>
            </a>
            @if (route.shadowRoute) {
              <a [routerLink]="route.shadowRoute" class="hidden pointer-events-none" tabindex="-1" aria-hidden="true"></a>
            }
          </div>
        }
      }
    }
  </div>
  <!-- <div class="self-end mt-6">
    <button
      type="button"
      (click)="onExpandToggle()"
      class="transition-all text-foreground-primary-40 hover:text-foreground-primary-100"
      [ngClass]="{
        'translate-x-[0px]': vm().expanded,
        'translate-x-[-24px]': !vm().expanded,
      }"
    >
      <svg-icon [key]="vm().expanded ? 'chevron-left-40' : 'chevron-right-40'" size="40"></svg-icon>
    </button>
  </div> -->
</div>
